export enum ErrorCode {
  // Validation Errors
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  INVALID_PROMPT = 'INVALID_PROMPT',
  INVALID_FOLDER = 'INVALID_FOLDER',
  INVALID_VARIABLE = 'INVALID_VARIABLE',

  // Not Found Errors
  NOT_FOUND = 'NOT_FOUND',
  PROMPT_NOT_FOUND = 'PROMPT_NOT_FOUND',
  FOLDER_NOT_FOUND = 'FOLDER_NOT_FOUND',

  // Authorization Errors
  AUTHORIZATION_ERROR = 'AUTHORIZATION_ERROR',
  PREMIUM_FEATURE = 'PREMIUM_FEATURE',

  // Storage Errors
  STORAGE_ERROR = 'STORAGE_ERROR',
  SYNC_ERROR = 'SYNC_ERROR',

  // Business Rule Errors
  SPECIAL_FOLDER_MODIFICATION = 'SPECIAL_FOLDER_MODIFICATION',
  DUPLICATE_FOLDER_NAME = 'DUPLICATE_FOLDER_NAME',
  MAX_PROMPTS_REACHED = 'MAX_PROMPTS_REACHED',

  // System Errors
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  NETWORK_ERROR = 'NETWORK_ERROR',
}

export const ErrorMessages: Record<ErrorCode, string> = {
  [ErrorCode.VALIDATION_ERROR]: 'Validation error occurred',
  [ErrorCode.INVALID_PROMPT]: 'Invalid prompt data',
  [ErrorCode.INVALID_FOLDER]: 'Invalid folder data',
  [ErrorCode.INVALID_VARIABLE]: 'Invalid variable data',

  [ErrorCode.NOT_FOUND]: 'Resource not found',
  [ErrorCode.PROMPT_NOT_FOUND]: 'Prompt not found',
  [ErrorCode.FOLDER_NOT_FOUND]: 'Folder not found',

  [ErrorCode.AUTHORIZATION_ERROR]: 'Authorization error',
  [ErrorCode.PREMIUM_FEATURE]: 'This feature requires a premium subscription',

  [ErrorCode.STORAGE_ERROR]: 'Storage operation failed',
  [ErrorCode.SYNC_ERROR]: 'Synchronization error occurred',

  [ErrorCode.SPECIAL_FOLDER_MODIFICATION]: 'Special folders cannot be modified',
  [ErrorCode.DUPLICATE_FOLDER_NAME]: 'A folder with this name already exists',
  [ErrorCode.MAX_PROMPTS_REACHED]: 'Maximum number of prompts reached',

  [ErrorCode.INTERNAL_ERROR]: 'Internal system error occurred',
  [ErrorCode.NETWORK_ERROR]: 'Network error occurred',
};

export function getErrorMessage(code: ErrorCode, details?: string): string {
  const baseMessage = ErrorMessages[code];
  return details ? `${baseMessage}: ${details}` : baseMessage;
}
